import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { path: '/', label: t('nav.home') },
    { path: '/category/all', label: t('nav.category') },
    { path: '/about', label: t('nav.about') },
  ];

  const supportLinks = [
    { path: '/about#contact', label: t('footer.contact') },
    { path: '/about#faq', label: t('faq.title') },
    { path: '#download', label: t('nav.download') },
  ];

  return (
    <footer className="bg-background-900 text-background-100" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-trophy-line text-background-50 text-lg"></i>
              </div>
              <span className="text-xl font-bold font-heading text-background-50">大满贯</span>
            </div>
            <p className="text-background-400 text-sm leading-relaxed">
              {t('hero.desc').substring(0, 80)}...
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">帮助与支持</h4>
            <ul className="flex flex-col gap-2.5">
              {supportLinks.map((link) => (
                <li key={link.path}>
                  <a
                    href={link.path}
                    className="text-background-400 hover:text-primary-400 text-sm transition-colors duration-200"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-background-50 font-semibold mb-4 text-sm">{t('about.contact')}</h4>
            <ul className="flex flex-col gap-3 text-sm text-background-400">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line text-primary-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>support@damanjuapp.com</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line text-primary-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line text-primary-400 mt-0.5 w-4 h-4 flex items-center justify-center"></i>
                <span>北京市朝阳区建国路88号</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 pt-6 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-background-500 text-xs">
            {t('footer.copyright').replace('2026', String(currentYear))}
          </p>
          <div className="flex items-center gap-6">
            <a href="#" className="text-background-500 hover:text-primary-400 text-xs transition-colors duration-200" rel="nofollow">
              {t('footer.privacy')}
            </a>
            <a href="#" className="text-background-500 hover:text-primary-400 text-xs transition-colors duration-200" rel="nofollow">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}